import cx from 'classnames';
import * as React from 'react';

import './styles/Legend.scss';

// NOTE: prefer Fieldset `legend` prop

// TODO
// * Reconcile with Fieldset `size`

type Props = {
  children: React.ReactNode;
  className?: string;
};

export default class Legend extends React.Component<Props> {
  render() {
    const { children, className } = this.props;

    return <legend className={cx('Legend', className)}>{children}</legend>;
  }
}
